const stepLabels = [
  { step_title: "Project Description", step_description: "Review the details of project." },
  { step_title: "Model Objectives", step_description: "Define the model objectives, business context and key model risks." },
  {
    step_title: "Model Specifications",
    step_description: "Define the technical artifacts that describe the model(s) used in the system.",
    dropdown_label:
      "Choose another model specifications template",
  },
  { step_title: "System Specifications", step_description: "Define the documentation describing how the model is incorporated into the overall system." },
  {
    step_title: "Policy and Compliance",
    step_description: "Define the internal company policies and external regulations relevant to the model.",
    dropdown_label:
      "Choose another policy and compliance template",
  },
  { step_title: "Overview", step_description: "Review the details of the project so far." },
  { step_title: "Model Development Document", step_description: "Review the Model Development Document." },
];

export default stepLabels;
